"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const util_theme_sxc_1 = require("@hotelplan/util.theme.sxc");
const TextBlockWrapper_1 = __importDefault(require("./TextBlockWrapper"));
const TextBlockTitle = styled_components_1.default.h1((0, util_theme_sxc_1.sx2CssThemeFn)({
    mb: [2, 4],
    fontSize: [3, '30px'],
}));
const TextBlockText = styled_components_1.default.div(({ theme: { media, fontSizes } }) => ({
    fontSize: fontSizes[2],
    [media.tablet]: {
        fontSize: fontSizes[4],
    },
}));
const TextBlock = ({ title, text, id, className, }) => {
    return (react_1.default.createElement(TextBlockWrapper_1.default, { className: className },
        title && (react_1.default.createElement(TextBlockTitle, { className: "text-block-title", dangerouslySetInnerHTML: { __html: title } })),
        react_1.default.createElement(TextBlockText, { id: id, className: "text-block-text", dangerouslySetInnerHTML: { __html: text } })));
};
exports.default = TextBlock;
//# sourceMappingURL=TextBlock.js.map